import { ARTICLE_CONTENT_ID } from '../consts'

import renderRichText from './renderRichText'

import css from './ArticleContent.module.css'

export type ArticleContentProps = {
    richText: string
}

export default function ArticleContent({ richText }: ArticleContentProps) {
    return (
        <div id={ARTICLE_CONTENT_ID} className={css.articleContent}>
            {renderRichText(richText)}
        </div>
    )
}
